import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Benchmark, BenchmarkResponseData } from './benchmark.model';
import { arrayToDateMap } from '../../utils/chart-utils';
export interface BenchmarkState extends EntityState<Benchmark> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'benchmark' })
export class BenchmarkStore extends EntityStore<BenchmarkState> {
    constructor() {
        super();
    }

    akitaPreAddEntity(benchmark: Benchmark) {
        return {
            id: benchmark.id || benchmark.value,
            name: benchmark.name || benchmark.label,
            ...arrayToDateMap(benchmark.data as unknown as BenchmarkResponseData, 'data')
        };
    }

    akitaPreUpdateEntity(benchmark: Benchmark, newBenchmark: Benchmark) {
        return {
            id: benchmark.id,
            name: benchmark.name,
            ...arrayToDateMap(
                newBenchmark.data as unknown as BenchmarkResponseData,
                'data'
            )
        };
    }
}
